// Helper function to get the appropriate content based on language
export const getLocalizedContent = (englishContent, persianContent, language) => {
    if (language === 'persian' && persianContent) {
        return persianContent;
    }
    return englishContent || persianContent || '';
};

// Helper function to get the appropriate title based on language
export const getLocalizedTitle = (englishTitle, persianTitle, language) => {
    if (language === 'persian' && persianTitle) {
        return persianTitle;
    }
    return englishTitle || persianTitle || '';
};

// Helper function to get the appropriate description based on language
export const getLocalizedDescription = (englishDescription, persianDescription, language) => {
    if (language === 'persian' && persianDescription) {
        return persianDescription;
    }
    return englishDescription || persianDescription || '';
};

// Helper function to get the appropriate author based on language
export const getLocalizedAuthor = (englishAuthor, persianAuthor, language) => {
    if (language === 'persian' && persianAuthor) {
        return persianAuthor;
    }
    return englishAuthor || persianAuthor || '';
};

// Helper function to get text direction based on language
export const getTextDirection = (language) => {
    return language === 'persian' ? 'rtl' : 'ltr';
}; 